var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vs-card',[_c('apexchart',{attrs:{"type":"bar","height":_vm.getHeight,"options":_vm.compOpts,"series":_vm.config.series}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }